import { httpDelete } from "../httpService/httpService";
import { CancelTaskProps, CancelTaskResponse, CancelTaskType, DeleteTaskProps } from "./types/mainDatabaseServiceProps";

export const cancelTask = async (props: CancelTaskProps): Promise<CancelTaskResponse> => {
    const endpoint = props.type === CancelTaskType.OK ? "cancel-ok-waitingroom" : "cancel-an-waitingroom";
    return new Promise((resolve, reject) => {
        httpDelete(`${props.apiBase}/${endpoint}`, { ids: props.ids })
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const deleteTask = async (props: DeleteTaskProps): Promise<CancelTaskResponse> => {
    return new Promise((resolve, reject) => {
        httpDelete(`${props.apiBase}/delete`, { dataBaseObjects: props.dataBaseObjects, reason: props.reason })
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}
